// Witcore Suite - Version 1.0.0
// Copyright(c) 2024 Witcore LLC. All rights reserved.

import React from 'react';
import { protect } from '../utils/protect.js';

const AvatarField = function ({ size, field }) {

  if ((field.value === null || field.value === undefined || field.value === '') && (field.paragraph === null || field.paragraph === undefined)) {
    return (<div />);
  }

  if (field.avatarField) {
    if (size === 'xl') {
      return (
        <div className="pe-3 pt-2">
          <div className="image-xl mx-auto">
            {field.avatarField.value ?
              <img src={field.avatarField.value} alt="Image" className="img-fluid rounded-circle" /> :
              null
            }
          </div>
        </div>
      );
    }
    else if (size === 'lg') {
      return (
        <div className="pe-2 pt-2">
          <div className="image-lg mx-auto">
            {field.avatarField.value ?
              <img src={field.avatarField.value} alt="Image" className="img-fluid rounded-circle" /> :
              null
            }
          </div>
        </div>
      );
    }
    else {
      return (
        <div className="pe-2">
          <div className="image-sm mx-auto bg-gray-lighter">
            {field.avatarField.value ?
              <img src={field.avatarField.value} alt="Image" className="img-fluid rounded-circle" /> :
              null
            }
          </div>
        </div>
      );
    }
  }
  else if (field.icon) {
    if (size === 'xl') {
      return (
        <div className="pe-3">
          <div className="text-gray">
            {React.createElement(field.icon, { size: 'xl' })}
          </div>
        </div>
      );
    }
    else if (size === 'lg') {
      return (
        <div className="pe-2">
          <div>
            {React.createElement(field.icon, { size: 'lg' })}
          </div>
        </div>
      );
    }
    else {
      return (
        <div className="pe-2">
          <div className={protect(field.color, field.value) ? 'text-' + protect(field.color, field.value) : null}>
            {React.createElement(field.icon, { size: 'sm' })}
          </div>
        </div>
      );
    }
  }
  else {
    return (<div />);
  }
  
}

export default AvatarField;